// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-detail-tasks-tile{width:100%}.location-detail-tasks-tile .location-detail-tasks-tile-empty{color:#6c757d;font-size:14px;padding:8px 0}", ""]);
// Exports
module.exports = exports;
